import { Company } from "@/data/mockCompanies";
import { MenuItem } from "@/components/MenuItemCard";

export class LocalStorageManager {
  private static getCompanyKey(companyId: string): string {
    return `digimenu_company_${companyId}`;
  }

  private static getCompaniesListKey(): string {
    return 'digimenu_companies_list';
  }

  // Salvar dados de uma empresa específica
  static saveCompanyData(companyId: string, data: Partial<Company>): void {
    const key = this.getCompanyKey(companyId);
    const existing = this.getCompanyData(companyId);
    const updated = { ...existing, ...data };
    localStorage.setItem(key, JSON.stringify(updated));
  }

  // Buscar dados de uma empresa específica
  static getCompanyData(companyId: string): Partial<Company> {
    const key = this.getCompanyKey(companyId);
    const data = localStorage.getItem(key);
    return data ? JSON.parse(data) : {};
  }

  // Salvar lista de empresas ativas
  static saveCompaniesList(companies: Company[]): void {
    const key = this.getCompaniesListKey();
    localStorage.setItem(key, JSON.stringify(companies));
  }

  // Buscar lista de empresas ativas
  static getCompaniesList(): Company[] {
    const key = this.getCompaniesListKey();
    const data = localStorage.getItem(key);
    return data ? JSON.parse(data) : [];
  }

  // Salvar menu items de uma empresa
  static saveMenuItems(companyId: string, menuItems: MenuItem[]): void {
    this.saveCompanyData(companyId, { menuItems });
  }

  // Buscar menu items de uma empresa
  static getMenuItems(companyId: string): MenuItem[] {
    const data = this.getCompanyData(companyId);
    return data.menuItems || [];
  }

  // Salvar categorias de uma empresa
  static saveCategories(companyId: string, categories: Array<{id: string; name: string; order: number}>): void {
    this.saveCompanyData(companyId, { categories });
  }

  // Buscar categorias de uma empresa
  static getCategories(companyId: string): Array<{id: string; name: string; order: number}> {
    const data = this.getCompanyData(companyId);
    return data.categories || [];
  }

  // Salvar configurações da empresa
  static saveCompanySettings(companyId: string, settings: {
    name?: string;
    phone?: string;
    email?: string;
    address?: string;
    workingHours?: string;
    logo?: string;
  }): void {
    this.saveCompanyData(companyId, settings);
  }

  // Salvar tema da empresa
  static saveThemeSettings(companyId: string, theme: { primaryColor: string; accentColor: string }): void {
    this.saveCompanyData(companyId, { theme });
  }

  // Limpar dados de uma empresa
  static clearCompanyData(companyId: string): void {
    const key = this.getCompanyKey(companyId);
    localStorage.removeItem(key);
  }

  // Limpar todos os dados
  static clearAllData(): void {
    const keys = Object.keys(localStorage).filter(key => key.startsWith('digimenu_'));
    keys.forEach(key => localStorage.removeItem(key));
  }
}